/**
 * 验证url的可访问性，返回携带blobURL或""的promise
 * @param urls 图片url数组, 如果url_1不可用会自动验证url_2以此类推, 都不可用则返回Promise<"">
 * @return Promise<string>
 */
const verifyImageAccessibility = (
  urls: string[],
  callback?: (url: string, index?: number) => void,
): Promise<string> =>
  fetch(urls[0])
    .then(response => {
      if (response.ok) {
        return response.blob();
      } else {
        return Promise.reject('404');
      }
    })
    .then(blob => {
      const blobURL = URL.createObjectURL(blob);
      if (typeof callback === 'function') {
        callback(blobURL);
      }
      return blobURL;
    })
    .catch(() => {
      if (urls[1]) {
        const newUrls = [...urls];
        newUrls.shift();
        return verifyImageAccessibility(newUrls, callback);
      } else {
        if (typeof callback === 'function') {
          callback('');
        }
        return '';
      }
    });

export default verifyImageAccessibility;
